import { render } from "./Hotspot24.vue?vue&type=template&id=3c90c78a&scoped=true&ts=true"
import script from "./Hotspot24.vue?vue&type=script&lang=ts"
export * from "./Hotspot24.vue?vue&type=script&lang=ts"

import "./Hotspot24.vue?vue&type=style&index=0&id=3c90c78a&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c90c78a"]])

export default __exports__